import React from 'react'

import JobOffersSimpleList from '../job-offers/SimpleList'
import { useCompanyJobOffers } from '../job-offers/hooks'
import { useI18N } from '../../../libraries/i18n/hook'
import Loading from '../../components/layout/Loading'
import useSWRImmutable from 'swr/immutable'
import { getCompany } from '../../../api/companies'

type Props = { companyId: number }
const CompanyJobOffers: React.FC<Props> = ({ companyId }) => {
  const { t } = useI18N()
  const { data: companyData, isLoading: isLoadingCompany } = useSWRImmutable(['company', companyId], () => getCompany(companyId))

  if(isLoadingCompany) { return <Loading /> }

  return (
    <div>
      <h3>{t('jobs.title', undefined, companyData?.languageCode)}</h3>
      <JobOffersSimpleList queryFn={() => useCompanyJobOffers(companyId)} />
    </div>
  )
}

export default CompanyJobOffers
